import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { getData } from '../../Actions/DropDown/getData';
import { getReferral } from '../../Actions/DropDown/getReferral';
import { getReferrals } from '../../Actions/DropDown/getReferrals';

class Select extends React.PureComponent {
  constructor(props) {
    super(props);

    const { searchable, editable, value, options } = this.props;
    let search = '';
    let searchvalue = 0;

    if (searchable && value) {
      if (editable) {
        search = this.findByValue(options, parseInt(value, 10));
        searchvalue = parseInt(value, 10);
      } else if (!editable) {
        search = this.findByKey(options, value);
        if (search) {
          searchvalue = search.id;
        }
      }
    }

    this.state = {
      visible: true,
      search: search ? search.value : '',
      searchvalue,
      options: this.props.options,
      defaultOptions: this.props.options,
      focus: false,
    };
  }

  componentWillMount() {
    if (this.props.dataKey === 'referral') {
      this.props.getReferrals();
    } else if (this.props.dataKey === 'referrals') {
      if (this.props.referralId) this.props.getReferral(this.props.referralId);
    } else {
      this.props.getData({ key: this.props.dataKey });
    }
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.scrollToSelected();

    if (this.search && this.props.autofocus === true) {
      this.search.focus();
    }
  }

  componentWillReceiveProps(props) {
    // console.log(props);
    if (props.dataKey === 'referrals' && props.referralId && props.referralId !== this.props.referralId) {
      this.props.getReferral(props.referralId);
      this.setState({ search: '' });
    } else if (props.options && props.options.length === 1) {
      this.props.onChange(props.options[0][(props.editable ? 'id' : 'key')]);
      this.setState({ visible: false });
      return;
    }
    this.setState({ visible: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.focus && this.state.focus !== prevState.focus) {
      this.handleFocus();
    }

    this.scrollToSelected(true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
    document.removeEventListener('focus', this.onFocus);
    document.removeEventListener('blur', this.onBlur);
    document.removeEventListener('change', this.updateSearch);
  }

  onFocus = () => {
    // this.state.focus ? document.removeEventListener('click', this.handleOutsideClick, false) : document.addEventListener('click', this.handleOutsideClick, false);
    document.removeEventListener('click', this.handleOutsideClick, false);

    // this.setState({ focus: true, options: this.state.defaultOptions, search: '' });
    this.setState({ focus: true, options: this.props.options, defaultOptions: this.props.options, search: '' });
    if (isMobile) { this.props.openPopup(); }
  }

  onBlur = () => {
    document.addEventListener('click', this.handleOutsideClick, false);
  }

  getNewOptionsList = (options, value) => {
    if (options && options.length > 0 && value && value.length > 0) {
      return options.filter(item => item.value.toLowerCase().includes(value));
    }

    return options;
  }

  findByValue(options, value) {
    let results = options;

    if (!options || options.length < 1) {
      results = this.state.defaultOptions;
    }

    if (!results) {
      return null;
    }

    return results.filter(object => object.id === value)[0];
  }

  findByKey(options, key) {
    let results = options;

    if (!options || options.length < 1) {
      results = this.state.defaultOptions;
    }

    if (!results) {
      return null;
    }

    return results.filter(object => object.key === key)[0];
  }

  publishOption(value) {
    let publishValue = value;
    if (typeof (value) === 'undefined') {
      publishValue = this.state.searchvalue;
    }

    return this.findByValue(null, publishValue);
  }

  updateSearch = (e) => {
    let val = e.target.value;

    if (!val) { val = ''; }
    let options = this.state.defaultOptions;
    options = this.getNewOptionsList(options, val.toLowerCase());

    this.setState({ search: val, options });
  };

  handleFocus() {
    if (this.state.options.length > 0) {
      const element = this.select;
      const { clientHeight } = document.documentElement;
      const viewportHeight = Math.max(clientHeight, window.innerHeight || 0);
      const elementPos = element.getBoundingClientRect();
      const selectHeight = viewportHeight - elementPos.top - 20;

      element.style.maxHeight = `${selectHeight}px`;

      this.scrollToSelected(true, 'selected');
    }
  }

  handleOutsideClick = (e) => {
    if (this.searchBox && this.searchBox.contains(e.target)) {
      return;
    }

    let search = '';
    if (this.state.searchvalue && this.props.searchable) {
      const option = this.findByValue(null, this.state.searchvalue);
      if (option) { search = option.value; }
    }

    this.setState({ focus: false, search });
  }

  chooseOption(value) {
    let currentValue = this.state.searchvalue;
    const option = this.findByValue(this.state.defaultOptions, value);

    currentValue = option.id;
    const search = option.value;
    const options = this.state.defaultOptions;

    this.setState({ searchvalue: currentValue, search, options, focus: false });

    setTimeout(() => {
      const publishOption = this.publishOption(currentValue);
      const data = this.props.editable ? publishOption.id : publishOption.key;

      this.props.onChange.call(null, data.toString(), this.state, this.props);
    }, 50);

    if (this.props.searchable) {
      this.search.blur();
      if (isMobile) { this.props.closePopup(); }
    }
  }

  scrollToSelected(force = false, selected = 'hover') {
    if ((!force && (!this.select || !this.state.focus || this.state.options.length < 1)) || !this.selectOptions) {
      return;
    }

    const selectedItem = this.selectOptions.querySelector('.selected');

    if (selectedItem) {
      const searchOffset = this.search ? this.search.clientHeight : 0;
      this.select.scrollTop = selectedItem.offsetTop - searchOffset - 200 / 2 + selectedItem.clientHeight / 2;
    }
  }

  update(e) {
    this.props.onChange(e.target.value);
  }

  titleCase(str) {
    return str.toLowerCase().split(' ').map(function (word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }

  render() {
    if (!this.state.visible) {
      return (
        <input type="text" disabled value={this.props.options[0].value} className="text-input-field" />
      );
    }

    let visibleStr = 'Select One...';
    if (this.props.value) visibleStr = this.props.value;
    if (this.props.editable && this.props.options) {
      this.props.options.map((o) => {
        if (this.props.value.toString() === o.id.toString()) visibleStr = this.titleCase(o.value);
        return null;
      });
    }

    if (this.props.searchable) {
      return (
        <div className="niceselect-wrapper select-search-box" ref={(searchBox) => { this.searchBox = searchBox; }}>
          <input type="hidden" name={this.props.name} defaultValue={this.state.searchvalue} />
          <input type="text" ref={(search) => { this.search = search; }} onFocus={this.onFocus} onBlur={this.onBlur} onChange={this.updateSearch} className="select-search-box-search" value={this.state.search} placeholder="Select One..." />

          <div className={this.state.focus ? 'select-search-box-select display' : 'select-search-box-select'} ref={(select) => { this.select = select; }}>
            <ul className="select-search-box-options" ref={(selectOptions) => { this.selectOptions = selectOptions; }}>
              <li data-value={-1}>Please Select</li>
              { this.props.options.length === 0 ? <li data-value={-1}>Loading...</li> : null}
              { this.state.options.map(o => (
                <li
                  role="selectItem"
                  data-value={this.props.editable ? o.id : o.key}
                  key={o.id}
                  onClick={() => this.chooseOption(o.id)}
                  className={o.id === this.state.searchvalue ? 'selected' : ''}
                >
                  {this.titleCase(o.value)}
                </li>
              ), this) }
            </ul>
          </div>
        </div>
      );
    }

    return (
        <div className={this.props.value ? 'niceselect-wrapper' : 'niceselect-wrapper niceselect-default'}>
            <span className='niceselect-text'>{visibleStr}</span>
            <select onChange={this.update} value={this.props.value} className='js-nice-select' name={this.props.name} autoComplete='off'>
                <option value=''>Please Select</option>
                {this.props.options.length === 0 ? <option value=''>Loading...</option> : null}
                {this.props.options.map((o) => (
                    <option value={this.props.editable ? o.id : o.key} key={o.id}>
                        {this.titleCase(o.value)}
                    </option>
                ))}
            </select>
        </div>
    );
  }
}

Select.defaultProps = {
  searchable: false,
  autofocus: false,
};

Select.propTypes = {
  dataKey: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  editable: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  getReferrals: PropTypes.func.isRequired,
  getReferral: PropTypes.func.isRequired,
  searchable: PropTypes.bool,
  autofocus: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const data = {
    options: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].options : [],
    editable: state.dropdowns[ownProps.dataKey] ? state.dropdowns[ownProps.dataKey].editable : 0,
  };

  if (ownProps.dataKey === 'referrals' && ownProps.level === 2 && state.dropdowns.referrallevel2) {
    data.options = state.dropdowns.referrallevel2.options ? state.dropdowns.referrallevel2.options : [];
  }

  if (ownProps.dataKey === 'referrals' && ownProps.level === 3 && state.dropdowns.referrallevel3) {
    data.options = state.dropdowns.referrallevel3.options ? state.dropdowns.referrallevel3.options : [];
  }

  if (data.options) {
    data.options.sort((a, b) => {
      if (a.rank && b.rank) return a.rank > b.rank ? 1 : -1;
      if (a.value && b.value) return a.value > b.value ? 1 : -1;
    });
  }

  return data;
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    getData: (p) => {
      dispatch(getData(p));
    },
    getReferrals: () => {
      dispatch(getReferrals());
    },
    getReferral: (id) => {
      dispatch(getReferral(id));
    },
  }
);

const SelectLink = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Select);

export default SelectLink;



// WEBPACK FOOTER //
// ./src/Components/Inputs/Select.jsx